import React, { useState } from 'react';
import { productApi } from '@/services/productApi';
import toast from 'react-hot-toast';

// Örnek ürünler
const SAMPLE_PRODUCTS = [
  {
    title: 'Kırmızı Gül Buketi',
    basePrice: 199.99,
    categories: ['Güller'],
    images: ['🌹'],
    description: 'Taze kırmızı güllerin güzel buketi',
    status: 'active' as const,
  },
  {
    title: 'Moonlight Grace Orkide',
    basePrice: 289.50,
    categories: ['Orkideler'],
    images: ['🪴'],
    description: 'Zarif beyaz orkide ürünü',
    status: 'active' as const,
  },
  {
    title: 'Pembe Papatya Aranjmanı',
    basePrice: 249.99,
    categories: ['Buketler'],
    images: ['💐'],
    description: 'Renkli papatya ve yeşillikler',
    status: 'active' as const,
  },
  {
    title: 'Lüks Çikolata Seti',
    basePrice: 159.50,
    categories: ['Çokolatalar'],
    images: ['🍫'],
    description: 'Belgili çikolata şekerleri',
    status: 'active' as const,
  },
];

export const Debug: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [productCount, setProductCount] = useState(0);

  const seedProducts = async () => {
    try {
      setLoading(true);
      for (const product of SAMPLE_PRODUCTS) {
        await productApi.createProduct({
          title: product.title,
          slug: product.title.toLowerCase().replace(/\s+/g, '-'),
          basePrice: product.basePrice,
          campaignPrice: product.basePrice,
          costPrice: 0,
          categories: product.categories,
          images: product.images,
          description: product.description,
          status: product.status,
          tags: [],
          sku: '',
          stock: 100,
          trackInventory: false,
          isAvailable: true,
          isSameDayDelivery: false,
          deliveryFee: 0,
          seoTitle: product.title,
          seoMetaDescription: product.description,
          vendorIds: [],
          extras: [],
          discountPercentage: 0,
        });
      }
      toast.success(`✅ ${SAMPLE_PRODUCTS.length} ürün eklendi!`);
      checkProducts();
    } catch (error: any) {
      console.error('Hata:', error);
      toast.error(error.message || 'Ürün eklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const checkProducts = async () => {
    try {
      const { products } = await productApi.getAllProducts();
      setProductCount(products.length);
    } catch (error: any) {
      console.error('Hata:', error);
      toast.error(error.message || 'Ürünler kontrol edilirken hata oluştu');
    }
  };

  React.useEffect(() => {
    checkProducts();
  }, []);

  return (
    <div className="p-8 bg-white rounded-lg shadow">
      <h1 className="text-2xl font-bold mb-6">🔧 Debug & Test Panel</h1>
      
      <div className="bg-blue-50 p-4 rounded mb-6">
        <h2 className="font-semibold mb-2">Firestore Durum</h2>
        <p className="text-lg">📊 Toplamda <strong>{productCount}</strong> ürün var</p>
      </div>

      <div className="space-y-3">
        <button
          onClick={seedProducts}
          disabled={loading}
          className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-4 rounded disabled:opacity-50"
        >
          {loading ? '⏳ Ekleniyor...' : '✅ 4 Örnek Ürün Ekle'}
        </button>

        <button
          onClick={checkProducts}
          disabled={loading}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-4 rounded disabled:opacity-50"
        >
          {loading ? '⏳ Kontrol ediliyor...' : '🔄 Ürünleri Kontrol Et'}
        </button>
      </div>

      <div className="mt-8 p-4 bg-gray-100 rounded">
        <h3 className="font-semibold mb-2">📋 Test Ürünleri:</h3>
        <ul className="space-y-1 text-sm">
          {SAMPLE_PRODUCTS.map((p, i) => (
            <li key={i}>
              {p.images[0]} {p.title} - {p.basePrice}₺
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Debug;
